import { CONST } from "../CONST";
import { MinigameScene } from "../scenes/generic/MinigameScene";

export default class ContinueButton extends Phaser.GameObjects.Image {
    constructor(x: number, y: number, scene: MinigameScene, texture: string, levelData: () => any){
        super(scene, x, y, texture);

        this.setInteractive({useHandCursor: true});
        this.on("pointerup", ()=> {
            let data = levelData();
            scene.arcadeContinueLevel(data);
        });
        scene.add.existing(this);
    }
}